import { useCallback, useEffect, useRef } from "react";

export const useDebounce = (callback, delay = 300) => {
    const timeoutRef = useRef();
    const callbackRef = useRef(callback);

    // Keep callback ref updated to prevent stale closures
    useEffect(() => {
        callbackRef.current = callback;
    }, [callback]);

    const cancel = useCallback(() => {
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
            timeoutRef.current = null;
        }
    }, []);

    const debounced = useCallback(
        (...args) => {
            cancel();
            timeoutRef.current = setTimeout(() => {
                callbackRef.current(...args);
            }, delay);
        },
        [delay, cancel]
    );

    // Cleanup on unmount
    useEffect(() => {
        return () => cancel();
    }, [cancel]);

    return debounced;
};
